import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact';
import { useEffect, useState } from 'preact/hooks';

import NoResults from './NoResults';
import Products from './Products';
import Toolbar from './Toolbar';
import Sidebar from './Sidebar';
import SidebarCustomized from './SidebarCustomized';

import BottomToolbar from './BottomToolbar';
import SelectedFilters from './SelectedFilters';
import Loader from './elements/Loader';
import { MoreButton } from './elements';
import Skeleton from './Skeleton';

export default function Serp() {
  const {
    response: { products },
    loading,
  } = useAppState();
  const foundProducts = products && products.total > 0;
  const toggleButtonId = 'toggle-mobile-sidebar';

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto"
      data-nosto-element="search"
    >
      {/* {(foundProducts || (loading && foundProducts)) && (
      )} */}
      <div
        class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5"
        style={loading ? 'position: relative;' : ''}
      >
        {foundProducts ? (
          <>
            {!isMobileView && (
              <div class="section-header text-center nsc-search-header--desktop">
                <h2>Search Results</h2>
              </div>
            )}

            <Toolbar lableFor={toggleButtonId}>
              {isMobileView && (
                <div class=" nsc-search-header--mobile">
                  <h2>Search Results</h2>
                </div>
              )}
            </Toolbar>

            <SidebarCustomized
              isMobileView={isMobileView}
              toggleId={toggleButtonId}
            >
              <SelectedFilters />
            </SidebarCustomized>
            {isMobileView && <SelectedFilters />}
            <Products />
            {/* <BottomToolbar /> */}
            <MoreButton />
          </>
        ) : loading ? (
          <Skeleton />
        ) : (
          <NoResults />
        )}
        {/* <Loader /> */}

        {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
        {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
      </div>
    </div>
  );
}
